import UltMeta, { Meta } from "./UltMeta";

/**
 * 任务模块枚举
 */
class TaskBizModule extends UltMeta {
    INVENTORY_TRADE = new Meta("INVENTORY_TRADE", "进销存");
    WAREHOUSE_BIZ = new Meta("WAREHOUSE_BIZ", "仓储业务");
    WAREHOUSE_MGMT = new Meta("WAREHOUSE_MGMT", "仓储管理");
}
export const TASK_BIZ_MODULE = new TaskBizModule();

/**
 * 任务类型枚举
 */
class TaskType extends UltMeta {
    EXPORT = new Meta("EXPORT", "导出");
    PRINT = new Meta("PRINT", "打印");
    REPORT_PACKAGE = new Meta("REPORT_PACKAGE", "报表打包");
    DOWNLOAD = new Meta("DOWNLOAD", "下载");
}
export const TASK_TYPE = new TaskType();

/**
 * 任务模块枚举
 */
class TaskBusinessType extends UltMeta {
    ACCOUNTS_RECEIVABLE = new Meta("ACCOUNTS_RECEIVABLE", "应收管理");
    ACCOUNTS_PAYABLE = new Meta("ACCOUNTS_PAYABLE", "应付管理");
    WAREHOUSE_FEE = new Meta("WAREHOUSE_FEE", "仓储费用");
    OUTBOUND = new Meta("OUTBOUND", "出库");
    INBOUND = new Meta("INBOUND", "入库");
    PLEDGE = new Meta("PLEDGE", "质押");
    INVENTORY_CHECK = new Meta("INVENTORY_CHECK", "盘点");
    TRANSFER = new Meta("TRANSFER", "过户");
    STOCK_SUMMARY = new Meta("STOCK_SUMMARY", "库存汇总");
    STOCK_DETAIL = new Meta("STOCK_DETAIL", "库存明细");
    PROFIT_CALC = new Meta("PROFIT_CALC", "收益测算");
    REPORT_PACKAGE = new Meta("REPORT_PACKAGE", "报表打包");
}
export const TASK_BUSINESS_TYPE = new TaskBusinessType();

/**
 * 任务完成状态枚举
 */
class TaskStatus extends UltMeta {
    NOT_COMPLETED = new Meta(0, "未完成");
    COMPLETED = new Meta(1, "已完成");
    FAILED = new Meta(2, "失败");
}
export const TASK_STATUS = new TaskStatus();

/**
 * 任务错误代码枚举
 */
class TaskErrorType extends UltMeta {
    GENERATE_FAIL = new Meta("GENERATE_FAIL", "生成失败");
    UPLOAD_FAIL = new Meta("UPLOAD_FAIL", "上传失败");
}
export const TASK_ERROR_TYPE = new TaskErrorType();

/**
 * 下载状态枚举
 */
class TaskDownloadState extends UltMeta {
    NOT_DOWNLOADED = new Meta(0, "未下载");
    DOWNLOADED = new Meta(1, "已下载");
}
export const TASK_DOWNLOAD_STATE = new TaskDownloadState();
